<div style="background-color: #ffffff;">
    <div class="loading-frame" *ngIf="isInitializing">
        <div class="loading-content">
            <!-- <div class="spinner"></div> -->
            <img src="./assets/images/view_progress.gif" alt="Loading..." class="spinner">
            <p>Logging in...</p>
        </div>
    </div>
    <div class="root" *ngIf="debugMode">
        <h6>Debug Mode</h6>
        <div class="activeCalls">
            <pre>Active Calls:</pre>
            <app-active-call [phoneCall]="call" [index]="i" *ngFor="let call of activeCalls; index as i"></app-active-call>
        </div>
        <div class="activeParties">
            <pre>Active Parties</pre>
            <app-active-party [party]="party" [index]="i" *ngFor="let party of activeParties; index as i"></app-active-party>
        </div>
    </div>
</div>
